(function() {
    "use strict";

    function CookieConsent() {
        var global = {
            analyticsScriptsLoaded: false,
            functionalScriptsLoaded: false,
            embeddedContentLoaded: false
        };

        var fn = {
            init: function() {
                var consent = fn.getStoredConsent();

                fn.setupGtag();
                fn.loadTagManager();

                if (consent) {
                    fn.onConsentGiven(consent);
                } else if (window.BMCookieConsent && typeof window.BMCookieConsent.preferenceGiven === 'function' && window.BMCookieConsent.preferenceGiven()) {
                    consent = window.BMCookieConsent.getPreferences();
                    fn.storeConsent(consent);
                    fn.onConsentGiven(consent);
                } else {
                    document.addEventListener('bmcc-consent-selected', function(e) {
                        var consent = e.detail;
                        fn.storeConsent(consent);
                        fn.onConsentGiven(consent);
                    });
                    fn.updateGtagConsent({
                        ad_storage: 'denied',
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        analytics_storage: 'denied'
                    });
                }
            },

            getStoredConsent: function() {
                return JSON.parse(localStorage.getItem(window.filterableContent.cookieStorageKey) || null);
            },

            storeConsent: function(consent) {
                localStorage.setItem(window.filterableContent.cookieStorageKey, JSON.stringify(consent));
            },

            setupGtag: function() {
                window.dataLayer = window.dataLayer || [];
                window.gtag = function() { window.dataLayer.push(arguments); };

                gtag('js', new Date());

                // Set default consent settings
                gtag('consent', 'default', {
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'analytics_storage': 'denied'
                });

                // Initially configure gtag to not store cookies and anonymize IPs
                gtag('config', trackingScripts.gtmContainerId, {
                    'storage': 'none',
                    'anonymize_ip': true,
                    'send_page_view': true // Ensures page view event is sent
                });
            },

            onConsentGiven: function(consent) {
                const gtmConsent = {
                    'flo_personalization_storage': 'denied',
                    'flo_analytics_storage': 'denied',
                    'flo_ad_storage': 'denied',
                    'flo_ad_user_data': 'denied',
                    'flo_ad_personalization': 'denied'
                };

                if (consent.analytics && !global.analyticsScriptsLoaded) {
                    global.analyticsScriptsLoaded = true;
                    gtmConsent.flo_analytics_storage = 'granted';
                }

                if (consent.necessary && !global.functionalScriptsLoaded) {
                    global.functionalScriptsLoaded = true;
                    // Suspect that this consent mode should be moved into embedded content consents
                    gtmConsent.flo_personalization_storage = 'granted';
                }

                if (consent.embeds && !global.embeddedContentLoaded) {
                    window.BMCookieConsent.loadEmbeddedContent();
                    global.embeddedContentLoaded = true;
                    global.advertisingContentLoaded = true;
                    gtmConsent.flo_ad_storage = 'granted';
                    gtmConsent.flo_ad_user_data = 'granted';
                    gtmConsent.flo_ad_personalization = 'granted';
                }

                fn.updateGtagConsent(gtmConsent, consent);

                var customerSearchIframe = jQuery("#flocert-customer-search-widget iframe");
                if (customerSearchIframe.length) {
                    customerSearchIframe[0].contentWindow.postMessage(JSON.stringify({
                        'embedded': consent.embeds,
                        'analytics': consent.analytics,
                    }), '*');
                }
            },

            updateGtagConsent: function(gtmConsent, consent) {
                if (typeof gtag === 'function') {
                    const configUpdates = {
                        ad_storage: gtmConsent.flo_ad_storage,
                        ad_user_data: gtmConsent.flo_ad_user_data,
                        ad_personalization: gtmConsent.flo_ad_personalization,
                        analytics_storage: gtmConsent.flo_analytics_storage
                    };

                    gtag("consent", "update", configUpdates);

                    if (consent && consent.analytics) {
                        gtag('config', trackingScripts.gtmContainerId, {
                            'storage': 'auto',
                            'anonymize_ip': false
                        });
                    }

                    window.dataLayer.push({
                        'event': 'flo_cookie_consent_changed'
                    });
                }
            },

            loadTagManager: function(callback) {
                if (!trackingScripts.gtmContainerId) {
                    return;
                }

                // Load GTM
                (function(w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js'
                    });
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    j.onload = callback;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', trackingScripts.gtmContainerId);
            }
        };

        jQuery(fn.init);
    }

    new CookieConsent();
})();
